import {
  BadgeCheckIcon,
  LocationIcon,
  OutlinedCalendarIcon,
  OutlinedStarIcon,
} from "@App/Components/common/Icons";
import { GarageBadge } from "@App/Components/GarageBadge";
import type { Garage } from "@App/types";
import { GarageHasNationwideService } from "@App/utils/conditionals/garages";
import type React from "react";
import { useTranslation } from "react-i18next";

type GarageListItemBadgeProps = {
  garage: Garage;
  nearest?: boolean | null;
  earliestAvailable?: boolean | null;
  bestReviewed?: boolean | null;
  authorized?: boolean | null;
  makeRoomForRibbon?: boolean | null;
};

export const GarageListItemBadge: React.FC<GarageListItemBadgeProps> = (
  props: GarageListItemBadgeProps,
) => {
  const { t } = useTranslation();

  return (
    <div
      className={`absolute z-10 top-0 left-0 lg:left-auto flex gap-1 ${
        props.makeRoomForRibbon ? "lg:right-28" : "lg:right-10"
      }`}
    >
      {props.nearest && (
        <GarageBadge
          icon={<LocationIcon className={"h-3 w-3 mr-1 fill-white"} />}
          name={
            GarageHasNationwideService(props.garage)
              ? t("badges.mobileService")
              : t("badges.smallestDistance")
          }
        />
      )}
      {props.earliestAvailable && (
        <GarageBadge
          icon={<OutlinedCalendarIcon className={"h-3 w-3 mr-1 fill-white"} />}
          name={t("badges.earliestAppointment")}
        />
      )}
      {props.bestReviewed && (
        <GarageBadge
          icon={<OutlinedStarIcon className={"h-3 w-3 mr-1 fill-white"} />}
          name={t("badges.bestRating")}
          hint={t("garageList.badges.best-reviewed-hint")}
        />
      )}
      {props.authorized && (
        <GarageBadge
          icon={<BadgeCheckIcon className={"h-3 w-3 mr-1 fill-white"} />}
          name={t("badges.authorizedGarage")}
        />
      )}
    </div>
  );
};
